import type { Bytes } from "@pdfking/tfunc"

/**
 * Main PDF engine interface for processing PDF documents
 */
export type PdfEngineOptions = {
  readonly unit_to_px: number
  readonly stroke_width: number
  readonly file_cache: string
  readonly chunk_size: Bytes
  readonly image_resolution: number
  readonly scale_bleed: number
}
